<div class="custom-dropdown" [class.disabled]="disabled">
  <button class="dropdown-toggle" (click)="toggleDropdown()" [disabled]="disabled">
    {{ getSelectedLabel() || placeholder }}
    <span class="pi pi-chevron-down"></span>
  </button>

  <ul class="dropdown-menu" *ngIf="dropdownOpen">
    <ng-container *ngFor="let option of options">
      <li [class.has-children]="option.children?.length > 0">
        <a
          href="#"
          (click)="selectOption(option, $event)"
          [class.active]="isSelected(option)"
          [attr.data-tooltip]="option.tooltip ? option.tooltip : null"
        >
          {{ option[optionLabel] }}
          <span *ngIf="option.children?.length > 0" class="submenu-arrow">&#9656;</span>
        </a>

        <!-- Nested submenu -->
        <ul class="submenu" *ngIf="option.children?.length > 0">
          <li *ngFor="let child of option.children">
            <a
              href="#"
              (click)="selectOption(child, $event)"
              [class.active]="isSelected(child)"
              [attr.data-tooltip]="child.tooltip ? child.tooltip : null"
            >
              {{ child[optionLabel] }}
            </a>
          </li>
        </ul>
      </li>
    </ng-container>
  </ul>
</div>
